<header class="page-header" *ngIf="title">
  <h3 class="page-title">{{ title }}</h3>
  <p *ngIf="description">{{ description }}</p>
</header>